module.exports = __webpack_public_path__ + "img/9788957984901.686c8735.jpg";